import {Record} from 'immutable';

import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';
import {type REVENUE_TARGET_TYPES} from 'web-app/react/plans/revenue-report/constants';
import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';

export interface RevenueDetailsStateProps {
    readonly behaviors?: any;
    readonly fetching: boolean;
    readonly revenueData?: any;
    readonly lastUpdatedAt?: string;
    readonly csv?: string;
    readonly targetType?: REVENUE_TARGET_TYPES;
}

export class RevenueDetailsState extends Record<RevenueDetailsStateProps>({
    behaviors: undefined,
    fetching: false,
    revenueData: undefined,
    lastUpdatedAt: undefined,
    csv: undefined,
    targetType: undefined,
}) {}

export default makeReducer<RevenueDetailsState>(
    [
        match(Actions.fetch, (state, {payload}) =>
            state.merge({
                revenueData: undefined,
                fetching: true,
                targetType: payload.targetType,
            }),
        ),
        match(Actions.fetchSuccess, (state, {payload}) =>
            state.merge({
                fetching: false,
                revenueData: payload.response,
                lastUpdatedAt: payload.response.lastUpdatedAt,
                csv: payload.response.csv,
                behaviors: new BehaviorsCollection(payload.response.behaviors),
            }),
        ),
        match(Actions.fetchFailed, state =>
            state.merge({
                fetching: false,
            }),
        ),
    ],
    new RevenueDetailsState(),
);
